import { useState } from "react";
import { PageLoader, Navbar, Footer, Toast } from "../components/shared";
import "../styles/globals.css";

export default function Donate() {
  const [toast, setToast] = useState<{ msg: string; type: "success" | "error" | "info" } | null>(null);

  const copyToClipboard = (text: string, label: string) => {
    navigator.clipboard.writeText(text);
    setToast({ msg: `${label} copié !`, type: "success" });
    setTimeout(() => setToast(null), 2000);
  };

  return (
    <>
      <PageLoader />
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}

      <div className="container">
        <Navbar backLink={{ href: "/", label: "Accueil", icon: "fas fa-arrow-left" }} />

        <section style={{
          maxWidth: 700,
          margin: "3rem auto",
          padding: "2rem",
          textAlign: "center",
          animation: "fadeUp 0.6s ease-out both"
        }}>
          {/* Message principal */}
          <div style={{
            background: "rgba(13,16,24,0.75)",
            backdropFilter: "blur(14px)",
            border: "1px solid rgba(110,231,179,0.18)",
            borderRadius: "2rem",
            padding: "3rem 2rem",
            marginBottom: "2rem"
          }}>
            <i className="fas fa-heart" style={{
              fontSize: "3rem",
              color: "#6EE7B3",
              marginBottom: "1.5rem",
              display: "block"
            }} />
            <h1 style={{
              fontSize: "clamp(1.8rem, 5vw, 2.5rem)",
              fontWeight: 700,
              marginBottom: "1.5rem",
              color: "#F0F3FA"
            }}>
              Soutenir QuevvyTickets
            </h1>
            <p style={{
              color: "#C9D6FF",
              fontSize: "1.1rem",
              lineHeight: 1.7,
              marginBottom: "1rem"
            }}>
              Envoyez-nous un message pour faire un don.
            </p>
            <p style={{
              color: "#8896B3",
              fontSize: "0.95rem",
              lineHeight: 1.6
            }}>
              Nous vous répondrons dans les plus brefs délais avec toutes les informations nécessaires.
            </p>
          </div>

          {/* Contacts */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            alignItems: "stretch"
          }}>
            {/* Email 1 */}
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "1rem",
              background: "rgba(13,16,24,0.6)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(110,231,179,0.15)",
              borderRadius: "1rem",
              padding: "1rem 1.5rem",
              cursor: "pointer",
              transition: "all 0.3s"
            }}
              onClick={() => copyToClipboard("info@quevvy.com", "Email info@quevvy.com")}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(110,231,179,0.4)"; e.currentTarget.style.background = "rgba(13,16,24,0.8)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(110,231,179,0.15)"; e.currentTarget.style.background = "rgba(13,16,24,0.6)"; }}>
              <div style={{
                width: 45,
                height: 45,
                borderRadius: "0.8rem",
                background: "rgba(110,231,179,0.1)",
                border: "1px solid rgba(110,231,179,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#6EE7B3"
              }}>
                <i className="fas fa-envelope" style={{ fontSize: "1.3rem" }} />
              </div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <p style={{ fontSize: "0.7rem", color: "#8896B3", marginBottom: 2 }}>Email</p>
                <p style={{ color: "#F0F3FA", fontSize: "1rem", fontWeight: 500 }}>info@quevvy.com</p>
              </div>
              <i className="fas fa-copy" style={{ color: "#6EE7B3", opacity: 0.6, fontSize: "0.9rem" }} />
            </div>

            {/* Email 2 */}
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "1rem",
              background: "rgba(13,16,24,0.6)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(110,231,179,0.15)",
              borderRadius: "1rem",
              padding: "1rem 1.5rem",
              cursor: "pointer",
              transition: "all 0.3s"
            }}
              onClick={() => copyToClipboard("contact@quevvy.com", "Email contact@quevvy.com")}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(110,231,179,0.4)"; e.currentTarget.style.background = "rgba(13,16,24,0.8)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(110,231,179,0.15)"; e.currentTarget.style.background = "rgba(13,16,24,0.6)"; }}>
              <div style={{
                width: 45,
                height: 45,
                borderRadius: "0.8rem",
                background: "rgba(110,231,179,0.1)",
                border: "1px solid rgba(110,231,179,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#6EE7B3"
              }}>
                <i className="fas fa-envelope" style={{ fontSize: "1.3rem" }} />
              </div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <p style={{ fontSize: "0.7rem", color: "#8896B3", marginBottom: 2 }}>Email</p>
                <p style={{ color: "#F0F3FA", fontSize: "1rem", fontWeight: 500 }}>contact@quevvy.com</p>
              </div>
              <i className="fas fa-copy" style={{ color: "#6EE7B3", opacity: 0.6, fontSize: "0.9rem" }} />
            </div>

            {/* WhatsApp */}
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "1rem",
              background: "rgba(13,16,24,0.6)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(110,231,179,0.15)",
              borderRadius: "1rem",
              padding: "1rem 1.5rem",
              cursor: "pointer",
              transition: "all 0.3s"
            }}
              onClick={() => {
                window.open("https://wa.me/250792871952", "_blank");
                setToast({ msg: "Ouverture WhatsApp...", type: "info" });
                setTimeout(() => setToast(null), 1500);
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(110,231,179,0.4)"; e.currentTarget.style.background = "rgba(13,16,24,0.8)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(110,231,179,0.15)"; e.currentTarget.style.background = "rgba(13,16,24,0.6)"; }}>
              <div style={{
                width: 45,
                height: 45,
                borderRadius: "0.8rem",
                background: "rgba(37, 211, 102, 0.1)",
                border: "1px solid rgba(37, 211, 102, 0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#25D366"
              }}>
                <i className="fab fa-whatsapp" style={{ fontSize: "1.5rem" }} />
              </div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <p style={{ fontSize: "0.7rem", color: "#8896B3", marginBottom: 2 }}>WhatsApp</p>
                <p style={{ color: "#F0F3FA", fontSize: "1rem", fontWeight: 500 }}>+250 792 871 952</p>
              </div>
              <i className="fas fa-external-link-alt" style={{ color: "#25D366", opacity: 0.6, fontSize: "0.8rem" }} />
            </div>
          </div>

          {/* Petit rappel */}
          <p style={{
            color: "#4B5563",
            fontSize: "0.8rem",
            marginTop: "2rem",
            padding: "0.75rem",
            background: "rgba(0,0,0,0.3)",
            borderRadius: "0.8rem"
          }}>
            <i className="fas fa-clock" style={{ marginRight: "0.5rem" }} />
            Réponse sous 24h maximum
          </p>
        </section>

        <Footer />
      </div>
    </>
  );
}